import {
	createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import EventEmitter from 'events';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElIconModules from '@element-plus/icons'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import {
	ElMessage,
	ElLoading
} from 'element-plus'
import $ from 'jquery'
const app = createApp(App)
for (const iconName in ElIconModules) {
	if (Reflect.has(ElIconModules, iconName)) {
		const item = ElIconModules[iconName]
		app.component(iconName, item)
	}
}
app.config.globalProperties.$axios = axios
if (process.env.NODE_ENV === 'development') {
	axios.defaults.baseURL = '/dptapi';
} else {
	console.log = () => {}
	axios.defaults.baseURL = 'https://zcjzcd.com/api/public';
}
app.use(jquery).use(ElMessage).use(ElLoading).use(store).use(router).use(ElementPlus, {
	locale: zhCn,
}).mount('#app')